import { memo } from "react";
import { useTranslation } from "react-i18next";
import { Box, FlexColBox, Link } from "../../common/components";
import { spacing } from "../../styles/theme";
import { useThemeBreakpoints } from "../../utils/themeUtils";
import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";

const EmptyCart = () => {
  const { t } = useTranslation();
  const { isMobile } = useThemeBreakpoints();
  const navigate = useNavigate();

  return (
    <Box
      px={{ xs: spacing.wrapperMobile, lg: spacing.wrapperDesktop }}
      pt={{ xs: spacing.wrapperMobile, lg: spacing.wrapperDesktop }}
      pb={{ xs: spacing.xlMobile, lg: spacing.xlDesktop }}
    >
      {!isMobile && (
        <Link startIcon="keyboard_arrow_left" onClick={() => navigate(-1)}>
          {t("general.back")}
        </Link>
      )}
      <FlexColBox
        mt={{ xs: spacing.regularMobile, lg: spacing.regularDesktop }}
        ml={{ xs: 0, lg: "128px" }}
        gap={{ xs: spacing.regularMobile, lg: spacing.regularDesktop }}
      >
        <Typography variant="h1">{t("checkout.title")}</Typography>
        <Typography variant="textRegular" data-test="cart.emptyCart">
          {t("checkout.cart_empty")}
        </Typography>
      </FlexColBox>
    </Box>
  );
};

export default memo(EmptyCart);
